import { useFeatureFlag } from '@fs/zion-flags'

// Gates the record outline highlight (RecordBoundingBoxHighlight, from @fs/zion-image-viewer).
// When off, the record highlight layer keeps using MemoryHighlight, which draws a ring only while
// the highlight is hovered or selected - so record outlines stay invisible, as they were before.
export const RECORD_OUTLINE_HIGHLIGHTS_FLAG = 'rip_sharedImageViewer_recordOutlineHighlights'

/**
 * Whether the record outline highlight is enabled.
 *
 * @returns {boolean} true when records should be drawn with a visible outline.
 */
export default function useRecordOutlineHighlightsEnabled() {
  const flag = useFeatureFlag(RECORD_OUTLINE_HIGHLIGHTS_FLAG)
  return Boolean(flag?.isOn)
}
